import { ControllerSpawner } from "@components/ControllerSpawner";
//import type { PlayerController } from "@components/PlayerController";
import { SpecificController } from "@components/SpecificController";
import type { Transform } from "@components/Transform";
import { OverlayInterface, setElementVisibility } from "@components/UI/OverlayInterface";
import type { Engine } from "@core/Engine";

import { SetupShadertoyCanvas } from "@game/ShadertoyIntegration/shadertoyCanvas"


export class ProjectPresentation {
    //datas
    projectName: string
    description: string
    link: string

    overlay: string = ""
    onOverlayLoaded: ((parentDiv: HTMLDivElement) => void) | undefined

    controllerSpawner: ControllerSpawner | undefined
    viewPointTransform: Transform | undefined

    disableNavigationKeys = false

    GenerateP5jsOverlay(link: string) {
        //load overlay with a loading span in background
        this.overlay = `
        <div style="aspect-ratio: 7/8; height:100%;  ">
            <iframe src="${link}" style = "position: relative;top:0;left:0; width:100%;height:100%;border: none;pointer-events: auto;overflow: hidden;z-index: 2;"></iframe>
            <div style="position: absolute;left:50%;top:50%;transform: translate(-50%, -50%); color: white; font-family: Arial, sans-serif; font-size: 18px; background: rgba(0, 0, 0, 0.5); padding: 10px 20px; border-radius: 10px;z-index: 0;">
                <span style = "">Loading ...</span>
            </div>
        </div>

        `
        return this
    }
    GenerateShadertoyOverlay(shaderId: number, engine: Engine) {
        // load game/ShadertoyIntegration/shadertoyCanvas.html as text
        {
            this.overlay = `
            <div style="width:100%; height:100%;" shader-id="${shaderId}" pointer-events: none;>
                <div class="shader-root" style="width: 100%; height: 100%;pointer-events: none;">
                    <canvas id="shaderCanvas" style="width: 100%; height: 100%;pointer-events: none;"></canvas>
                </div>
            </div>
            `
            this.onOverlayLoaded = (parent) => SetupShadertoyCanvas(parent, engine)
        }
        this.disableNavigationKeys = true
        return this
    }

    constructor(projectName: string, description: string, link: string, controllerSpawner?: ControllerSpawner, overlay?: string, viewPointTransform?: Transform) {
        this.projectName = projectName
        this.description = description
        this.link = link
        this.controllerSpawner = controllerSpawner
        this.viewPointTransform = viewPointTransform
        this.overlay = overlay || ""
    }
}
export class ProjectNavigator extends SpecificController {
    overlay!: OverlayInterface
    visitButton!: HTMLButtonElement
    projects: ProjectPresentation[] = []
    currentProjectId = 0
    _lastSelectedProject: ProjectPresentation | null = null
    get currentProject(): ProjectPresentation {
        return this.projects[this.currentProjectId]
    }
    setup(_data: any) {
        super.setup(_data)
        this.overlay = this.gameObject.addComponent(OverlayInterface, {
            innerHTML: `
            <!-- Add project div in the middle -->
            <div style="position: absolute;padding: 80px 20px;box-sizing: border-box; inset: 0; box-sizing: border-box;width: 100%; height: 100%; background: rgba(0, 0, 0, 0.0);">
                <div style = "position: relative; width: 100%; height: 100%; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                    <div id="overviewDiv" style="position: absolute; top: 0; left: 0; width: 25%; height: 100%; background: rgba(0, 0, 0, 0); border-radius: 10px; pointer-events: none;"></div>
                    <div id="projectDiv" style = "position: absolute;left:25%;width: 50%; height: 100%; color: white; font-family: Arial, sans-serif; font-size: 24px; text-align: center; background: rgba(0, 0, 0, 0.0); border-radius: 10px; pointer-events: none;padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;"></div>
                    <div id="complementDiv" style="position: absolute; top: 0; left: 75%; width: 25%; height: 100%; background: rgba(0, 0, 0, 0); border-radius: 10px; pointer-events: none;"></div>
                </div>
            </div>
            <!-- Add left arrow button -->
            <input type="button" value="◀" id="leftArrow" style="position: absolute; bottom: 20px; left: 20px; font-size: 24px; color: white; background: rgba(0, 0, 0, 0.5); border: none; border-radius: 10px; width: 200px; height: 50px; cursor: pointer; pointer-events: auto;"/>
            <!-- Add right arrow button -->
            <input type="button" value="▶" id="rightArrow" style="position: absolute; bottom: 20px; right: 20px; font-size: 24px; color: white; background: rgba(0, 0, 0, 0.5); border: none; border-radius: 10px; width: 200px; height: 50px; cursor: pointer; pointer-events: auto;"/>
            <!-- Add visit button on the down (to enter the project controller)-->
            <input type="button" value="Visiter le projet" id="visitButton" style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); font-size: 24px; color: white; background: rgba(0, 0, 0, 0.5); border: none; border-radius: 10px; width: 200px; height: 50px; cursor: pointer; pointer-events: auto;"/>
            `})
        // Add event listeners to the arrow buttons
        this.overlay.element.querySelector('#leftArrow')?.addEventListener('click', this.previousProject.bind(this))
        this.overlay.element.querySelector('#rightArrow')?.addEventListener('click', this.nextProject.bind(this))
        this.visitButton = this.overlay.element.querySelector('#visitButton')!
        this.visitButton.addEventListener('click', this.visitProject.bind(this))
    }
    nextProject() {
        this.currentProjectId = (this.currentProjectId + 1) % this.projects.length
    }
    previousProject() {
        this.currentProjectId = (this.currentProjectId - 1 + this.projects.length) % this.projects.length
    }
    visitProject() {
        if (this.currentProject.controllerSpawner) {
            this.currentProject.controllerSpawner.spawnController()
        }
    }
    addProject(project: ProjectPresentation) {
        this.projects.push(project)
        if (project.controllerSpawner instanceof ControllerSpawner) {
            project.controllerSpawner.setPlayerController(this.playerController)
        }
        return this
    }
    start() {
    }
    updateActions(_dt: number): void {
        //set target to selected project viewpoint if it exists
        const project = this.currentProject
        if (project.viewPointTransform) {
            this.targetTransform = project.viewPointTransform.transformData;
        }
        setElementVisibility(this.visitButton, project.controllerSpawner !== undefined);

        if (!project.disableNavigationKeys) {
            if (this.engine.input.onPress('ArrowLeft')) this.previousProject()
            if (this.engine.input.onPress('ArrowRight')) this.nextProject()
            if (this.engine.input.onPress('Enter') || this.engine.input.onPress('ArrowDown')) this.visitProject()
            if (this.engine.input.onPress('Escape') || this.engine.input.onPress('ArrowUp')) this.exitController()
        }
    }
    update(_dt: number): void {
        if (this._lastSelectedProject !== this.currentProject && this.currentProject) {
            console.log("Project changed to:", this.currentProject.projectName)
            const projectDiv = this.overlay.element.querySelector('#projectDiv') as HTMLDivElement
            projectDiv.innerHTML = this.currentProject.overlay

            //set overview usinrg name, description, link etc
            const overviewDiv = this.overlay.element.querySelector('#overviewDiv') as HTMLDivElement
            overviewDiv.innerHTML = `
            <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); border-radius: 10px; pointer-events: none;">
                <div style=" padding: 20px; color: white; font-family: Arial, sans-serif; font-size: 24px; pointer-events: none;">${this.currentProject.projectName}</div>
                <div style=" padding-left: 20px; padding-right: 20px; color: white; font-family: Arial, sans-serif; font-size: 14px; pointer-events: none;">${this.currentProject.description}</div>
                <div style=" padding: 20px; color: white; font-family: Arial, sans-serif; font-size: 14px; pointer-events: auto;">
                    <a id="visitLink" href="${this.currentProject.link}" target="_blank" style="color: lightblue; text-decoration: underline;">Lien vers le projet</a>
                </div>
            </div>
            `
            if (this.currentProject.link === "") {
                const visitLink = this.overlay.element.querySelector('#visitLink') as HTMLAnchorElement
                setElementVisibility(visitLink, false)
            }

            this.currentProject.onOverlayLoaded?.(projectDiv)

            this._lastSelectedProject = this.currentProject
        }
        this.overlay.enabled = !this.interupted
    }
    onDestroy(): void {
        super.onDestroy()
        this.gameObject.removeComponent(this.overlay)
    }

}